import React, { useEffect, useRef, useState } from 'react';
import "./styles.css";

/**
 * @function UINumberInput 
 * @param {STRING} className - Additional CSS class that we can pass to the UINumberInput component.
 * @param {STRING} value - Pass the default value to the UINumberInput component.
 * @param {STRING} placeHolder - Pass the placeHolder value to the UINumberInput component.
 * @param {React.Component} children - React components that's being wrapped by the UINumberInput component.
 * @returns {React.Component}
 * @example
 * <UINumberInput className="some-class" value="99" placeHolder="Some value" maxValue={999} maxLength={3} />
 */
export default function UINumberInput(props) {
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
  const type = props.type ?? "text";
  const maxLength = props.maxLength ?? 3;
  const maxValue = props.maxValue ?? 999;
  const inputField = useRef();
  const ignoreToggle = { ignoretoggle: props.ignoreToggle ? "true" : "false" };

  const [state, setState] = useState(props.value ?? "");

    const onChange = evt => {

    // Remove all non-numeric characters and accept values up to the maxValue.
    inputField.current.value = inputField.current.value.replace(/[^0-9]/g, "");
    if (inputField.current.value <= maxValue) {

      inputField.current.value = inputField.current.value.substring(0, maxLength);
      setState(inputField.current.value);

      if (props.onChange instanceof Function) {
        props.onChange(inputField.current.value, evt, inputField.current);
      }
    }
  };

  useEffect(() => setState(props.value ?? ""), [props.value]);

  return (
    <div className={`form-row flex-height uinumberinput ${className}`}>
      <div className="floating-label-input-container">
        <input className="floating-label-input form-row-input" maxLength={maxLength} ref={inputField}
          type={type} placeholder=" " value={state} onChange={onChange} {...dataPoint} {...ignoreToggle}></input>
        <label className="floating-label form-row-label">{props.placeHolder}</label>
      </div>
      <span className="form-row-info-text gray-text">
        {props.children}
      </span>
    </div>
  );
}